import { memo } from "react";
import SetShippingFeesPlugin from "@delivery-management/SetShippingFees/SetShippingFeesPlugin.tsx";
import { deliverySettings0, makeDeliverySettingsAvailable } from "@/data/DeliverySettingsHub.ts";
import { computed, selector, signal } from "@/react/core/reactive.ts";
import { DeliverySetting } from "@/data/DeliverySetting.ts";
import uuid from "time-uuid";
import { toast } from "react-toastify";
import { convertDocument, type DocDeepSignal } from "@/data/data-utils.ts";
import { dialogConfirmDelete } from "@/react/SetShippingFeesView/dialogConfirmDelete.tsx";
import GoogleMapsProvider from "@/react/core/GoogleMapsProvider.tsx";
import { makeOnlineProviderAvailable } from "@/data/OnlineProviderHub.ts";
import {
  DELIVERY_ZONE_COLORS,
  deliverySettingsRadius,
  deliverySettingsZone
} from "@/react/DeliveryManagementView/google-map-logic.ts";

export const [deliverySetting0, setDeliverySetting0] = signal<DocDeepSignal<DeliverySetting> | null>(null)
export const isCurrentDeliveryS = selector<DeliverySetting, string | undefined>(deliverySetting0, (p1: any, p2: {
  _id: any
}) => p2?._id === p1)
export const [deliveryMode, setDeliveryMode] = signal<"radius" | "zone">("radius")

export const isEmptySetting = computed(() => {
  if (deliveryMode() === 'radius' && deliverySettingsRadius().length === 0) return true
  return deliveryMode() === 'zone' && deliverySettingsZone().length === 0;
});

window.deliveryMode = deliveryMode
window.deliverySetting0 = deliverySetting0
window.deliverySettingsZone = deliverySettingsZone
window.deliverySettingsRadius = deliverySettingsRadius
window.isEmptySetting = isEmptySetting

export const addNewSetting = async (type: 'radius' | 'zone') => {
  const i = (deliverySettings0()?.length || 0) + 1
  const _id = uuid()
  const newSetting = await DeliverySetting.upsert({
    _id,
    zoneName: `Zone ${i}`,
    type,
    isEnable: true,
    color: DELIVERY_ZONE_COLORS[Math.floor(Math.random() * DELIVERY_ZONE_COLORS.length)]
  })
  setDeliverySetting0(convertDocument(newSetting, true))
  toast.success(`Success!`)
}

export const deleteCurrentSetting = async (d?: DocDeepSignal<DeliverySetting>) => {
  const setting = d || deliverySetting0()
  if (!setting) return
  await dialogConfirmDelete(async () => {
    await setting.doc?.incrementalRemove()
    if (setting.postalCode) {
      localStorage.removeItem(`polygon-${setting.postalCode}`)
    }
    toast.success(`Success!`)
  })
}
